import React, { ReactNode } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

interface MetricTooltipProps {
  title: string;
  description?: string;
  children?: ReactNode;
}

export const MetricTooltip = ({ title, description, children }: MetricTooltipProps) => (
  <Box width="35ch" px={3} py={2}>
    <Typography variant="h6" gutterBottom>
      {title}
    </Typography>
    {!!description && (
      <Typography variant="body2" color="textSecondary" gutterBottom>
        {description}
      </Typography>
    )}
    {children}
  </Box>
);
